export default function negativeModulo (n, m) {
  return ((n % m) + m) % m
}
